import { performFetch, performFileUpload } from './utils'
import { browserHistory } from 'react-router'

/**
 * Load jobs for a given person (uuid).
 *
 * @param {string} crew_uuid The UUID of the crewmember to retrieve the gear of.
 * @returns {Function} An action creator thunk.
 */
export function loadJobs(crew_uuid) {
    return performFetch({
        type: 'LOAD_JOBS',
        urlData: { crew_uuid },
    })
}

/**
 * Clear the currently-loaded job.
 *
 * @returns {Function} An action creator thunk.
 */
export function clearJob() {
    return { type: 'CLEAR_JOB' }
}

/**
 * Load jobs for a given person (uuid).
 *
 * @param {string} crew_uuid The UUID of the crewmember to retrieve the gear of.
 * @param {string} job_uuid The UUID of the job to retrieve.
 * @returns {Function} An action creator thunk.
 */
export function loadJob(crew_uuid, job_uuid) {
    return performFetch({
        type: 'LOAD_JOB',
        urlData: { crew_uuid, job_uuid },
    })
}

/**
 * Upload receipt for an invoice.
 *
 * @param {File} file - The file to upload.
 * @param {object} data - Any extra data to submit with the file.
 * @param {function} successCallback - A callback to call with the data returned from the API call.
 *                            This is particularly useful to be able to store the result of the upload
 *                            in the application's internal state.
 * @param {function} progressCallback - A callback to call as the upload progresses. This is
 *                            particularly useful to be able to show the progress of the upload live as
 *                            the file is uploaded.
 * @returns {Function} An action creator thunk.
 */
export function uploadReceipt(file, data, successCallback, progressCallback) {
    return performFileUpload({
        type: 'RECEIPT_UPLOAD',
        field: 'receipt',
        file,
        data,
        onSuccess: (data) => {
            // call the callback with the data we got from the API
            successCallback(data)

            // and dispatch the normal success event too
            return { type: 'RECEIPT_UPLOAD_SUCCESS', data }
        },
        onProgress: progressCallback,
    })
}

export function uploadReceiptError(errors) {
    return {
        type: 'RECEIPT_UPLOAD_ERROR',
        errors,
    }
}

export function submitInvoice(data) {
    return performFetch({
        type: 'SUBMIT_INVOICE',
        data,
        onSuccess: () => {
            browserHistory.push('/jobs')

            return { type: 'SUBMIT_INVOICE_SUCCESS', data }
        },
    })
}

export function submitRequestForOvertime(data, crew_uuid, job_uuid, successCallback) {
    return performFetch({
        type: 'REQUEST_OVERTIME',
        data,
        urlData: { crew_uuid, job_uuid },
        onSuccess: (data) => {
            successCallback()
            return { type: 'REQUEST_OVERTIME_SUCCESS', data }
        },
    })
}



// WEBPACK FOOTER //
// ./app/actions/jobs.js